import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  Fragment,
} from "react";
import { useNavigate } from "react-router-dom";
import TruPakInventoryCardList from "./MobileViews/TruPakInventory/TruPakInventoryCardList";
import Button from "../../../../components/Button";
import Table from "../../../../components/Table/Table";
import Popup from "../../../../components/PopupMenu/Popup";
import { ReactComponent as MoreActionsIcon } from "../../../../assets/more-actions.svg";
import { ReactComponent as MoreActionsMobileIcon } from "../../../../assets/more-actions-mobile.svg";
import backIcon from "../../../../assets/back_icon.svg";
import ProductController from "../../../../controllers/ProductController";
import { ScreenContext } from "../../../../contexts/ScreenContext";
import { useMediaQuery } from "react-responsive";
import styles from "./TruPakInventoryTable.module.css";
import { useTranslation } from "react-i18next";

const TruPakInventoryTable = ({
  goBackHandler,
  selectedGraph,
  windowHeight,
  inventoryTableData,
}) => {
  const { t } = useTranslation("trupak/inventoryTable")

  const [items, setItems] = useState([]);
  const [showPopup, setShowPopup] = useState(null);
  const [popupIndex, setPopupIndex] = useState(-1);

  const { smallScreen } = useContext(ScreenContext);

  const smScreen = useMediaQuery(smallScreen);

  const navigate = useNavigate();

  const ProductControllerInstance = new ProductController();

  const _controllerRef = useRef(ProductControllerInstance);

  const actionMenu = [
    {
      type: "canisterManagement",
      description: t("canisterAction"),
    },
    {
      type: "deviceReplenishment",
      description: t("replenishmentAction"),
    },
  ];

  const handleAction = (action) => {
    switch (action.type) {
      case "canisterManagement":
        navigate("/devices", {
          state: {
            dataFromDashboard: {
              source: "TruPakInventoryTable",
              actionItem: "canisterManagement",
              selectedTabIndex: 0,
              returnURL: "/dashboard",
              device: inventoryTableData[popupIndex]?.device,
              canister: inventoryTableData[popupIndex]?.canister,
              canisterNo: Number(
                inventoryTableData[popupIndex].canister.name.split("-")[2]
              ),
              canisterBarcode: inventoryTableData[popupIndex]?.canister.barcode,
              returnView: "TruPak",
              // selectedSite:
              //   typeof selectedSite === "object" ? selectedSite : null,
              selectedGraph: selectedGraph,
            },
          },
        });
        break;
      case "deviceReplenishment":
        navigate("/devices", {
          state: {
            dataFromDashboard: {
              source: "TruPakInventoryTable",
              selectedTabIndex: 2,
              returnURL: "/dashboard",
              returnView: "TruPak",
              // selectedSite:
              //   typeof selectedSite === "object" ? selectedSite : null,
              selectedGraph: selectedGraph,
            },
          },
        });
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    (() => {
      const tempItems = [];

      try {
        inventoryTableData.forEach((tableRow, index) => {
          const actions = (
            <div
              className={styles.TruPakInventoryTable__actionsContainer}
              onClick={(e) => {
                if (!showPopup) {
                  setShowPopup(true);
                  setPopupIndex(index);
                }
              }}
            >
              {smScreen ? <MoreActionsMobileIcon /> : <MoreActionsIcon />}
              {showPopup && popupIndex === index && (
                <Popup
                  menuItems={actionMenu}
                  onAction={(action) => {
                    setShowPopup(null);
                    setPopupIndex(-1);
                    handleAction(action);
                  }}
                  onClose={() => setShowPopup(null)}
                  rightJustify={true}
                />
              )}
            </div>
          );
          tempItems.push([
            tableRow?.device[0]?.name,
            tableRow?.canister?.name,
            _controllerRef.current.getDefaultName(tableRow.product[0]),
            tableRow?.min,
            tableRow?.max,
            tableRow?.quantity,
            // actions,
          ]);
        });
        setItems(tempItems);
      } catch (e) {
        console.log(e.message);
      }
    })();
  }, [showPopup, popupIndex, inventoryTableData]);

  const tableHeight = (+windowHeight - 200).toString() + "px";

  const headers = [
    t("col0"),
    t("col1"),
    t("col2"),
    t("col3"),
    t("col4"),
    t("col5"),
    <div className={styles.TruPakInventoryTable__actionsHeadingContainer}>
      {t("col6")}
    </div>,
  ];

  const DesktopView = (
    <Fragment>
      <div className={styles.TruPakInventoryTable__header}>
        <h1>{t("title")}</h1>
        <p>{t("contact")}: 555-555-5555</p>
      </div>
      <div
        style={{ height: tableHeight }}
        className={styles.TruPakInventoryTable__mainContainer}
      >
        {/* <p>{deviceName}</p> */}
        <div className={styles.TruPakInventoryTable__tableContainer}>
          <Table
            padScrollBar={true}
            // searchText={searchText}
            headers={headers}
            records={items}
            showPopup={showPopup}
            popupIndex={popupIndex}
            tableRowHeight={37}
            scrollAdjustConstant={160}
          />
        </div>
        <div className={styles.TruPakInventoryTable__buttonGroup}>
          <Button
            onClick={goBackHandler}
            labelName={t("backButtonLabel")}
            isPrimary={false}
            isDisabled={false}
            minWidth={null}
          />
        </div>
      </div>
    </Fragment>
  );

  const MobileView = (
    <div className={styles.TruPakInventoryTable__mainContainer}>
      <header className={styles.TruPakInventoryTable__header}>
        <div className={styles.TruPakInventoryTable__backButton}>
          <img src={backIcon} onClick={goBackHandler} />
        </div>
        <p>{t("title")}</p>
      </header>
      {
        <div className={styles.TruPakInventoryTable__cardListContainer}>
          <TruPakInventoryCardList headings={headers} data={items} />
        </div>
      }
    </div>
  );

  return smScreen ? MobileView : DesktopView;
};

export default TruPakInventoryTable;
